<h3>
  <span i18n="@@avatar-tab-title">Avatar</span>
</h3>
<app-submenu [items]="this.submenuService.SUBMENU_FOR_CONFIGURATION"></app-submenu>

<!-- Eingabezeile -->
<h3
  class="mt-4"
  i18n="@@prompt-options"
>Eingabezeile</h3>

<app-form-for-boolean
  [label]="this.showPrompt"
  [(value)]="this.config.promptbarActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
></app-form-for-boolean>
<app-form-for-boolean
  [label]="this.voiceInput"
  [(value)]="this.config.voiceInputActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-mic-usage-avatar">
    Das Mikrofon verbindet sich immer automatisch, sobald der Avatar verbunden ist. Ist diese Option aktiviert, hört der
    Bot sofort zu. Ist sie deaktiviert, bleibt das Mikrofon zunächst stummgeschaltet und du kannst es manuell
    aktivieren.
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectChat"
  [(value)]="this.config.switchToChat"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-swap-to-chat">
    Zusätzlicher Knopf, um zum Chat-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectVoice"
  [(value)]="this.config.switchToVoice"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-swap-to-voice">
    Zusätzlicher Knopf, um zum Audio-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.cancelThinking"
  [(value)]="this.config.cancelBotThinkingActive"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-cancel-thinking">
    Aktuell laufende Bot-Bearbeitung abbrechen
  </app-hint>
</app-form-for-boolean>

<h3
  class="mt-5"
  i18n="@@avatar-selection"
>Avatar-Auswahl</h3>
<div>
  <div class="avatar-grid">
    @for (avatar of this.avatars; track avatar; let i = $index) {
    <div
      (click)="selectAvatar(avatar)"
      class="avatar-card rounded-3 overflow-hidden cursor-pointer"
      [ngClass]="{
        'selected': this.config.avatarId === avatar.id,
        'ms-0': i === 0,
        'me-0': i === this.avatars.length - 1
      }"
    >
      <div
        class="avatar-inner"
        [ngStyle]="getInnerStyle(avatar.id)"
      >
        @if (this.config.useGreenscreen && this.config.backgroundUrl) {
        <div
          class="avatar-inner-bg"
          [style.background-image]="'url(' + this.config.backgroundUrl + ')'"
        ></div>
        }
        <img
          [src]="avatar.previewUrl"
          class="avatar-inner-img"
          alt=""
        >
      </div>
      <span
        class="avatar-name text-center position-absolute bottom-0 w-100"
        [ngClass]="{
          'bg-primary text-white': this.config.avatarId === avatar.id,
          'bg-white': this.config.avatarId !== avatar.id
        }"
      >{{ avatar.name }}</span>
    </div>
    }
  </div>
</div>

<!-- Background / Greenscreen -->
<h3
  class="mt-5"
  i18n="@@avatar-background-url"
>Hintergrund</h3>

<app-form-for-boolean
  [label]="this.greenscreen"
  [(value)]="this.config.useGreenscreen"
  [isDisabled]="this.config.fullscreenConfig?.active"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
>
  <app-hint i18n="@@hint-greenscreen-mode">
    Aktiviert den Greenscreen-Filter (Chroma-Key). Im Live-Stream hat der Avatar einen grünen Hintergrund – dieser wird
    durch dein Hintergrundbild ersetzt. Die Vorschaubilder in der Avatar-Auswahl zeigen keinen grünen Hintergrund – das
    ist beabsichtigt.
  </app-hint>
  @if (this.config.fullscreenConfig?.active) {
  <app-hint i18n="@@hint-greenscreen-forced-by-fullscreen">
    Im Fullscreen-Modus ist Greenscreen immer aktiv.
  </app-hint>
  }
</app-form-for-boolean>

<div class="row align-items-center mb-3 mt-2">
  <div class="col-3">
    <span i18n="@@background-url">Hintergrund-URL</span>
    <app-hint i18n="@@hint-avatar-background">
      URL zu einem Hintergrundbild für den Avatar. Wird nur genutzt, wenn Greenscreen aktiv ist.
    </app-hint>
  </div>
  <div class="col-6 lock-sensitive">
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.backgroundUrl"
      (ngModelChange)="saveConfig()"
      [placeholder]="'https://...'"
      [disabled]="!this.config.useGreenscreen"
    />
  </div>
</div>

<!-- Fullscreen-Modus -->
<h3
  class="mt-5"
  i18n="@@fullscreen-mode-title"
>Fullscreen-Modus</h3>

<app-form-for-boolean
  [label]="this.fullscreenMode"
  [(value)]="this.config.fullscreenConfig!.active"
  [colClass]="'col-3'"
  (valueChange)="toggleFullscreen()"
>
  <app-hint i18n="@@hint-fullscreen-mode">
    Zeigt den Avatar in einem eigenen Vollbild-Layout mit konfigurierbarem Header, Hintergrundbild über die
    komplette Fläche und allen Buttons/Eingabefeldern im Footer.
  </app-hint>
</app-form-for-boolean>

@if (this.config.fullscreenConfig?.active) {
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-left">Header links</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.left.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.left.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.left.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.left.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-center">Header Mitte</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.center.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.center.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.center.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.center.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@fullscreen-header-slot-right">Header rechts</span>
  </div>
  <div class="col-auto">
    <p-selectbutton
      [options]="this.headerSlotKindOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="this.config.fullscreenConfig!.header.right.kind"
      [unselectable]="true"
      (ngModelChange)="saveConfig()"
    ></p-selectbutton>
  </div>
  <div class="col lock-sensitive">
    @if (this.config.fullscreenConfig!.header.right.kind !== 'none') {
    <input
      pInputText
      class="w-100"
      [(ngModel)]="this.config.fullscreenConfig!.header.right.value"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
      [placeholder]="this.config.fullscreenConfig!.header.right.kind === 'image' ? 'https://...' : ''"
    />
    }
  </div>
</div>
}

<!-- Voice Configuration -->
<h3
  class="mt-5"
  i18n="@@avatar-voice-config"
>Stimme</h3>

<div class="row align-items-center mb-3">
  <div class="col-3">
    <span i18n="@@voice-model">Sprachmodell</span>
    <app-hint i18n="@@hint-choose-model">
      Auswahl des Sprachmodells
    </app-hint>
  </div>
  <div class="col lock-sensitive">
    <p-select
      [options]="this.elevenLabsModelOptions"
      [(ngModel)]="this.config.voiceConfig.model"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="saveConfig()"
    ></p-select>
  </div>
</div>

<app-form-for-boolean
  [label]="'Sprech-Boost'"
  [(value)]="this.config.voiceConfig.use_speaker_boost"
  [colClass]="'col-3'"
  (valueChange)="saveConfig()"
  i18n-label="@@voice-boost"
>
</app-form-for-boolean>

<!-- Stability Slider -->
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-stability">Stabilität</span>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@stability-emotional"
      >Emotional</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.config.voiceConfig.stability * 100"
        >
          {{ this.config.voiceConfig.stability | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.config.voiceConfig.stability"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="sliderChange(($event.value ?? 0) + '', 'stability')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span><span>0,5</span><span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@stability-monotone"
      >Monoton</span>
    </div>
  </div>
</div>

<!-- Similarity Slider -->
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-similarity">Ähnlichkeit</span>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@similarity-weak"
      >Schwach</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.config.voiceConfig.similarity_boost * 100"
        >
          {{ this.config.voiceConfig.similarity_boost | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.config.voiceConfig.similarity_boost"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="sliderChange(($event.value ?? 0) + '', 'similarity_boost')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span><span>0,5</span><span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@similarity-strong"
      >Stark</span>
    </div>
  </div>
</div>

<!-- Style Slider -->
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-style">Stil</span>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@style-emotional"
      >Schwach</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.config.voiceConfig.style * 100"
        >
          {{ this.config.voiceConfig.style | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.config.voiceConfig.style"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="sliderChange(($event.value ?? 0) + '', 'style')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span><span>0,5</span><span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@style-monotone"
      >Stark</span>
    </div>
  </div>
</div>

<!-- Speed Slider -->
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-speed">Sprechgeschwindigkeit</span>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@speed-emotional"
      >Langsam</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="(this.config.voiceConfig.speed - 0.7) / 0.5 * 100"
        >
          {{ this.config.voiceConfig.speed | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.config.voiceConfig.speed"
          [min]="0.7"
          [max]="1.2"
          [step]="0.1"
          (onSlideEnd)="sliderChange(($event.value ?? 0) + '', 'speed')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0,7</span><span>0,95</span><span>1,2</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@speed-monotone"
      >Schnell</span>
    </div>
  </div>
</div>

<!-- Stimmen-Auswahl -->
<h3 class="mt-5">
  <ng-container i18n="@@voice-selection">Stimmen-Auswahl</ng-container>
  <app-hint i18n="@@hint-voice-selection">
    Die obigen Einstellungen zur Audioausgabe beeinflussen leider nicht die Demodaten der verfügbaren Stimmen. Bitte
    dafür den Audio-Bot direkt öffnen.
  </app-hint>
</h3>
@if (this.voiceService.voices.length !== 0) {
<ul class="voice-list">
  @for (voice of this.voiceService.getVoicesByModel(this.config.voiceConfig.model); track $index) {
  <li
    class="voice-list-item"
    [ngClass]="{'active': voice.voiceId === this.config.voiceConfig.id}"
  >
    <div class="row align-items-center">
      <div
        class="col cursor-pointer"
        (click)="this.config.voiceConfig.id = voice.voiceId; saveConfig()"
      >
        <div class="voice-name">{{voice.name}}</div>
        <div class="voice-badges">
          @if (voice.labels.accent) {
          <span class="voice-badge">{{voice.labels.accent}}</span>
          }
          @if (voice.labels.age) {
          <span class="voice-badge">{{voice.labels.age}}</span>
          }
          @if (voice.labels.gender) {
          <span class="voice-badge">{{voice.labels.gender}}</span>
          }
          @if (voice.labels.description || voice.labels.descriptive) {
          <span class="voice-badge">{{voice.labels.description || voice.labels.descriptive}}</span>
          }
          @if (voice.labels.use_case) {
          <span class="voice-badge">{{voice.labels.use_case}}</span>
          }
        </div>
      </div>
      @let deData = this.voiceService.getLangByVoiceAndModel(voice.voiceId, 'de');
      @let enData = this.voiceService.getLangByVoiceAndModel(voice.voiceId, 'en');
      <div class="voice-audio-col text-center">
        @if (!deData) {
        <span class="text-secondary">-</span>
        }
        @if (deData) {
        <span
          class="language-flag"
          style="background-image: url('assets/de.svg');"
        >&nbsp;</span>
        }
        @if (deData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="deData.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId + '_de'"
        ></app-audio-btn>
        }
      </div>
      <div class="voice-audio-col text-center">
        @if (!enData) {
        <span class="text-secondary">-</span>
        }
        @if (enData) {
        <span
          class="language-flag"
          style="background-image: url('assets/en.svg');"
        >&nbsp;</span>
        }
        @if (enData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="enData.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId + '_en'"
        ></app-audio-btn>
        }
      </div>
      <div class="voice-audio-col text-center">
        @if (enData || deData) {
        <span class="text-secondary">-</span>
        }
        @if (!enData && !deData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="voice.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId"
        ></app-audio-btn>
        }
      </div>
    </div>
  </li>
  }
</ul>
}
@if (this.voiceService.voices.length === 0) {
<span i18n="@@voices-not-available">
  Aktuell besteht eine Störung beim Abruf der verfügbaren Stimmen.
</span>
}

<!-- Individueller CSS -->
<h3
  class="mt-5"
  i18n="@@css-individual"
>Individueller CSS</h3>
<app-codemirror-css
  [instruction]="this.rss.botConfig.customAvatarCss"
  [rows]="13"
  [botlyContext]="'Avatar-Bot'"
  [placeholder]="this.enterCustomCss"
  (finish)="this.rss.botConfig.customAvatarCss = $event; this.rss.saveBotConfigField('customAvatarCss')"
></app-codemirror-css>